import findIndex from 'lodash/findIndex';
import { playerStatuses } from './enums';

export const getChoices = (items, qsObj) => {
    const optionItems = items.reduce((res, el) => {
        const alreadyExist = Boolean(res.find((item) => {
            return item.locationName === el.locationName;
        }));

        if (!alreadyExist) {
            res.push({
                id: res.length + 1,
                locationName: el.locationName
            });
        }

        return res;
    }, []);

    const choicesInitial = [
        { label: 'Select course', value: '', selected: false }
    ];

    const optionItemsSorted = optionItems.sort((a, b) => {
        return a.locationName > b.locationName ? 1 : -1;
    });

    optionItemsSorted.forEach((option) => {
        choicesInitial.push({
            label: option.locationName,
            value: option.locationName,
            selected: false
        });
    });

    const choiceIndex = findIndex(choicesInitial, (choice) => (choice.value === qsObj.course));

    if (choiceIndex === -1) {
        choicesInitial[0].selected = true;
    } else {
        choicesInitial[choiceIndex].selected = true;
    }

    return choicesInitial;
};

export const getLocationNameToFilterBy = (players, locationId) => {
    if (!locationId) {
        return undefined;
    }
    const itemWithLocation = players.find((el) => {
        if (!el || !el.sitecoreData || !el.sitecoreData.scoringEngineEventId) {
            return false;
        }
        return el.sitecoreData.scoringEngineEventId === locationId;
    });

    if (!itemWithLocation) {
        return undefined;
    }
    return itemWithLocation.locationName;
};

export const getPlayerStatusSuffix = (playerStatus) => {
    const statusMap = {
        [playerStatuses.AMATEUR]: '(a)',
        [playerStatuses.REINSTATED]: '(a/r)'
    };

    return statusMap[playerStatus] || '';
};
